import { render, staticRenderFns } from "./KentPolice.vue?vue&type=template&id=77d18975&scoped=true"
import script from "./KentPolice.vue?vue&type=script&lang=js"
export * from "./KentPolice.vue?vue&type=script&lang=js"
import style0 from "./KentPolice.vue?vue&type=style&index=0&id=77d18975&prod&scoped=true&lang=css"
import style1 from "./KentPolice.vue?vue&type=style&index=1&id=77d18975&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d18975",
  null
  
)

export default component.exports